import React from 'react';
import { PageHero } from '../components/PageHero';
export function TermsOfServicePage() {
  return <>
      <PageHero title="Terms of Service" data-id="element-1466" />
      <section className="bg-white py-24" data-id="element-1467">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 prose prose-lg text-steel-600" data-id="element-1468">
          <p data-id="element-1469">Last updated: February 2025</p>
          <h3 data-id="element-1470">1. Introduction</h3>
          <p data-id="element-1471">
            These terms and conditions govern your use of the Chiltern Global
            website. By accessing this website, you accept these terms and
            conditions in full.
          </p>
          <h3 data-id="element-1472">2. Intellectual Property Rights</h3>
          <p data-id="element-1473">
            Unless otherwise stated, Chiltern Global Ltd and/or its licensors
            own the intellectual property rights in the website and material on
            the website. Subject to the license below, all these intellectual
            property rights are reserved.
          </p>
          <h3 data-id="element-1474">3. License to Use Website</h3>
          <p data-id="element-1475">
            You may view, download for caching purposes only, and print pages
            from the website for your own personal use, subject to the
            restrictions set out below and elsewhere in these terms and
            conditions.
          </p>
          <p data-id="element-1476">You must not:</p>
          <ul data-id="element-1477">
            <li data-id="element-1478">
              Republish material from this website (including republication on
              another website).
            </li>
            <li data-id="element-1479">Sell, rent or sub-license material from the website.</li>
            <li data-id="element-1480">
              Reproduce, duplicate, copy or otherwise exploit material on this
              website for a commercial purpose.
            </li>
          </ul>
          <h3 data-id="element-1481">4. Limitations of Liability</h3>
          <p data-id="element-1482">
            Chiltern Global Ltd will not be liable to you (whether under the law
            of contact, the law of torts or otherwise) in relation to the
            contents of, or use of, or otherwise in connection with, this
            website for any direct, indirect, special or consequential loss.
          </p>
          <h3 data-id="element-1483">5. Governing Law</h3>
          <p data-id="element-1484">
            These terms and conditions will be governed by and construed in
            accordance with English law, and any disputes relating to these
            terms and conditions will be subject to the exclusive jurisdiction
            of the courts of England and Wales.
          </p>
        </div>
      </section>
    </>;
}